import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getDistributionHistory = (pageSize, pageNum) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_DISTRIBUTUTION_HISTORY(pageSize, pageNum)
  );
};

export default getDistributionHistory;
